import { Component, inject } from '@angular/core';
import { AssetService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  AssetCreateDto,
  AssetDto,
  AssetExcelDownloadDto,
  AssetUpdateDto,
} from '../proxy/controlling/dtos/asset';
import { ASSET_CONFIG, ASSET_FIELDS } from './asset.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-asset',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, AssetService, ConfirmationService],
  templateUrl: './asset.html',
  styleUrl: './asset.scss',
})
export class Asset extends BaseCrudComponent<
  AssetDto,
  AssetCreateDto,
  AssetUpdateDto,
  AssetExcelDownloadDto
> {
  service = inject(AssetService);
  config = ASSET_CONFIG;
  fields = ASSET_FIELDS;

  protected prepareUpdateDto(data: any, selected: AssetDto): AssetUpdateDto {
    return {
      assetNumber: data.assetNumber,
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Asset';
  }
}
